import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { configureStore } from 'modules/redux-store';
import { client } from 'modules/prismic';
import { BlogContextProvider } from 'modules';
import { Footer, Layout, ScrollToTop } from 'main/components';

import { routes } from '../constants';

export const Routing = () => {
  const store = configureStore();

  React.useEffect(() => {
    const toggleWidget = () => {
      if (
        typeof window !== 'undefined' &&
        typeof (window as any).FreshworksWidget === 'function'
      ) {
        const isOrqaDeveloperProgramRoute =
          window.location.pathname === '/developer-program';

        if (isOrqaDeveloperProgramRoute) {
          (window as any).FreshworksWidget('hide');
        } else {
          (window as any).FreshworksWidget('show');
        }
      }
    };

    toggleWidget();

    const timeoutId = setTimeout(() => {
      toggleWidget();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  const isOrqaDeveloperProgramRoute =
    location.pathname === '/developer-program';
  if (!isOrqaDeveloperProgramRoute) {
    (window as any).FreshworksWidget('show');
  } else {
    (window as any).FreshworksWidget('hide');
  }

  return (
    <Provider store={store}>
      <BlogContextProvider>
        <ApolloProvider client={client}>
          <HelmetProvider>
            <BrowserRouter>
              <ScrollToTop>
                {isOrqaDeveloperProgramRoute ? (
                  <Route
                    render={({ location }) => (
                      <TransitionGroup>
                        <CSSTransition
                          key={location.key}
                          timeout={2000}
                          classNames="page-container"
                          unmountOnExit
                        >
                          <Switch location={location}>
                            {routes.map(({ path, Component, exact }) => (
                              <Route key={path} exact={exact} path={path}>
                                <div className="page-container">
                                  <div
                                    id="glass__effect"
                                    className="glass__effect"
                                  />
                                  <Component />
                                  {isOrqaDeveloperProgramRoute ? null : (
                                    <Footer />
                                  )}
                                </div>
                              </Route>
                            ))}
                          </Switch>
                        </CSSTransition>
                      </TransitionGroup>
                    )}
                  />
                ) : (
                  <Layout>
                    <Route
                      render={({ location }) => (
                        <TransitionGroup>
                          <CSSTransition
                            key={location.key}
                            timeout={2000}
                            classNames="page-container"
                            unmountOnExit
                          >
                            <Switch location={location}>
                              {routes.map(({ path, Component, exact }) => (
                                <Route key={path} exact={exact} path={path}>
                                  <div className="page-container">
                                    <div
                                      id="glass__effect"
                                      className="glass__effect"
                                    />
                                    <Component />
                                    <Footer />
                                  </div>
                                </Route>
                              ))}
                            </Switch>
                          </CSSTransition>
                        </TransitionGroup>
                      )}
                    />
                  </Layout>
                )}
              </ScrollToTop>
            </BrowserRouter>
          </HelmetProvider>
        </ApolloProvider>
      </BlogContextProvider>
    </Provider>
  );
};

export default withRouter(Routing);
